import React from 'react';
import styled from 'styled-components';

/**
 * Rich-renderer function that can be consumed by React-Rich-Text render in order
 * to generate a styled element based on a particular rich text node, and it's
 * children
 *
 * @function
 * @param {object} node rich-text node
 * @param {element} children collection of child rich-text nodes
 */

const RichOrderedList = (node, children) => <StyledRichOrderedList>{children}</StyledRichOrderedList>;

const StyledRichOrderedList = styled.ol`
  list-style: decimal outside;
  margin-left: 20px;

  p {
    margin-left: 10px;
  }

  li {
    margin-bottom: 0px;
  }

  li ul li {
    list-style: circle;
  }
`;

export default RichOrderedList;
